import React from "react";
import { Link } from "../../molecules/Link";

export const PaisSidebar = (props) => {
  return (
    <nav
      id={"sidebar"}
      className={"flex flex-col min-w-[13rem] min-h-screen bg-theme-blue text-white"}
    >
      <Link route={"/pais"}>{"Lista de Países"} </Link>
      <Link route={"/pais/crear"}>{"Crear País"}</Link>
      <Link route={"/departamento"}>{"Lista de Departamentos"}</Link>
      <Link route={"/departamento/crear"}>{"Crear Departamento"}</Link>
      <Link route={"/provincia"}>{"Lista de Provincias"}</Link>
      <Link route={"/provincia/crear"}>{"Crear Provincia"}</Link>
    </nav>
  );
};